import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import type {
  RegisterEdgeRequest,
  RegisterEdgeResponse,
} from '@/api/endpoints/edges'
import { edgesApi } from '@/api/endpoints/edges'
import { ApiError } from '@/api/types'
import { getErrorMessage } from '@/shared/utils/error-codes'

export function useRegisterEdge() {
  const queryClient = useQueryClient()
  return useMutation<RegisterEdgeResponse, Error, RegisterEdgeRequest>({
    mutationFn: (req) => edgesApi.register(req),
    onSuccess: () => {
      // Refresh edges list so the newly registered hub appears
      queryClient.invalidateQueries({ queryKey: ['edges'] })
    },
    onError: (error: Error) => {
      if (error instanceof ApiError) {
        toast.error(getErrorMessage(error.status, error.code))
      } else {
        toast.error('Failed to register edge')
      }
    },
  })
}
